import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Ana Sayfa', path: '/' },
  { label: 'Hizmetler', path: '/hizmetler' },
  { label: 'Hizmet Bölgelerimiz', path: '/hizmet-bolgeleri' },
  { label: 'Hakkımızda', path: '/hakkimizda' },
  { label: 'İletişim', path: '/iletisim' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/3f116279-fda4-4433-96b4-be34229c7c09.png"
            alt="Alfa Çilingir Logo"
            className="h-16 md:h-20 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-6">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                scrolled
                  ? location.pathname === link.path
                    ? 'text-orange-500'
                    : 'text-gray-700 hover:text-orange-500'
                  : location.pathname === link.path
                  ? 'text-orange-400'
                  : 'text-white hover:text-orange-300'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Phone CTA */}
        <a
          href="tel:05416247982"
          className="hidden md:flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-bold px-4 py-2 rounded-full whitespace-nowrap transition-all duration-200 cursor-pointer animate-pulse-slow text-sm"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-phone-fill text-base"></i>
          </span>
          0541 624 79 82
        </a>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer ${scrolled ? 'text-gray-700' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menüyü aç"
        >
          <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white shadow-lg border-t border-gray-100">
          <nav className="flex flex-col px-4 py-3 gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`py-3 px-2 text-sm font-medium border-b border-gray-50 cursor-pointer ${
                  location.pathname === link.path ? 'text-orange-500' : 'text-gray-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:05416247982"
              className="mt-3 flex items-center justify-center gap-2 bg-orange-500 text-white font-bold px-4 py-3 rounded-full whitespace-nowrap cursor-pointer"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill text-base"></i>
              </span>
              0541 624 79 82
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
